import React from 'react';
import { NavLink } from 'react-router-dom';
import './Footer.css';
import gobiernoLogo from './Imagenes/gobierno_logo.png';
import logoDpa from './Imagenes/Logo_DPA_blanco.png';
import facebookIcon from './assets/facebook.svg';
import instagramIcon from './assets/instagram.svg';
import youtubeIcon from './assets/youtube.svg';
import mailIcon from './assets/footer/mail.svg';
import telefonoIcon from './assets/footer/telefono.svg';
import ubicacionIcon from './assets/footer/ubicacion.svg';
import copy from './assets/copyright.svg';

const Footer = () => (
  <footer className="footer">
    <div className="footer-main">
      <div className="footer-col footer-brand">
        <img src={logoDpa} alt="Logo DPA" className="footer-dpa-logo" />
        <p>
          Direccion Provincial del Agua.
          <br />
          Ministerio de Obras Publicas.
          <br />
          Gobierno de la Provincia.
        </p>
      </div>

      <div className="footer-col footer-links">
        <h4>Enlaces</h4>
        <ul>
          <li><NavLink to="/">Inicio</NavLink></li>
          <li><NavLink to="/contactos">Contactos</NavLink></li>
          <li><NavLink to="/presentacion">Presentacion de documentacion</NavLink></li>
          <li><NavLink to="/mision">Mision</NavLink></li>
          <li><NavLink to="/funciones">Funciones</NavLink></li>
          <li><NavLink to="/autoridades">Autoridades</NavLink></li>
          <li><NavLink to="/licitaciones">Licitaciones</NavLink></li>
          <li><NavLink to="/tramites">Tramites</NavLink></li>
          <li><NavLink to="/webmail">Webmail</NavLink></li>
        </ul>
      </div>

      <div className="footer-col footer-contact">
        <h4>Contacto</h4>
        <ul>
          <li>
            <span className="footer-contact-icon">
              <img src={ubicacionIcon} alt="" aria-hidden="true" />
            </span>
            Simon Bolivar 1095, S. M. de Tucuman
          </li>
          <li>
            <span className="footer-contact-icon">
              <img src={telefonoIcon} alt="" aria-hidden="true" />
            </span>
            381-2621036
          </li>
          <li>
            <span className="footer-contact-icon">
              <img src={mailIcon} alt="" aria-hidden="true" />
            </span>
            <a href="mailto:mesadeentradas@dpatuc.com">mesadeentradas@dpatuc.com</a>
          </li>
        </ul>
      </div>

      <div className="footer-col footer-social">
        <h4>Siguenos</h4>
        <div className="footer-social-icons">
          <a
            href="https://www.facebook.com/p/Direcci%C3%B3n-Provincial-del-Agua-100064752878590/?locale=es_LA"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <img src={facebookIcon} alt="" className="footer-social-icon" />
          </a>
          <a
            href="https://www.instagram.com/tucdpa/?hl=es-la"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <img src={instagramIcon} alt="" className="footer-social-icon" />
          </a>
          <a
            href="https://www.youtube.com/@direccionprovincialdelagua7694"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
          >
            <img src={youtubeIcon} alt="" className="footer-social-icon" />
          </a>
        </div>
        <img src={gobiernoLogo} alt="Logo Gobierno de Tucuman" className="footer-gobierno-logo" />
      </div>
    </div>

    <div className="footer-bottom">
      <p className="footer-copyright">
        <img src={copy} alt="" aria-hidden="true" />
        <span>{new Date().getFullYear()} Direccion Provincial del Agua. Todos los derechos reservados.</span>
      </p>
 
    </div>
  </footer>
);

export default Footer;
